/* eslint-disable max-len */
import *  as React from "react"; 
import { TextField } from "@cmsgov/design-system-core";
import { addFonts } from "./../assets/Icons";
import { Button } from "reactstrap";  
import  ReCAPTCHA  from "react-google-recaptcha";


import * as constants from "../constants/index"; 
import axios from "axios"; 

addFonts();
export interface Props {
    label: string;
    name: string;
    value: string;
    handleChange: (e: any) => void;
    options: any;
}
  
interface BankSearchProps {
    onAction: () => void;
}
 

interface BankViewState {
    loading: boolean;
    bankName: string;
    fund: string;
    assetXferInd: string; 
    commentText: string;
    closedDate: string; 
    message: any;
    banklist: [];
    bankdeatails: any; 
    bankid: string; 
    isPayout: boolean;
    closedDays: number;
    url: any; 
    nodata: string;
    insuredIndicator: number;
    accountNo: string;
    token: string;
    siteKey: string;
} 
const payOutMessage = "Account status will only be available for 30 days following a bank failure. Information on your bank is available from the Failed Bank List page.";
  
class BankSearch extends React.Component<BankSearchProps, BankViewState> {   
  
    reRef;

    dataLoadErrorAlert() {
        this.setState({
            message: {
                type: "error",
                isOpen: true,
                text: ""
            },
     
      
            loading: false
        });

    }

    constructor(props: BankSearchProps) {
        super(props);
    
        this.state = {  
            loading: false,
            bankName: "", 
            fund: "",
            assetXferInd:"",
            commentText:"",
            closedDate: "",
            message: { type: "success", isOpen: false, text: "" },
            banklist: [],
            bankdeatails:[],
            bankid: "",
            isPayout:false,
            closedDays:0,
            url: {},
            nodata:"",
            insuredIndicator:-1,
            accountNo:"",
            token:"",
            siteKey:"", 
        }; 
        this.reRef = React.createRef<ReCAPTCHA>(); 
    }
     
    componentDidMount() {  
        // console.log("testing Key");
        this.getSiteKey();
    
        // console.log("SiteKey from Bank search : "  +  this.state.siteKey);
        const URI = constants.DRRIP_AII_API + "institutions/"  ;
        fetch(URI)
            .then(res => res.json())
            .then((data) => {
                this.setState({ banklist: data });   
            })
            .catch(err => {
                console.log(err); 
                alert("An Error has occurred");
                return null;
            });
    }
    handleOnChange = (e: any) => { 
        let that = this;   
        that.setAccountNumber(e.target.value); 
    };

    getBankData = () => {
   
        this.setState({
            assetXferInd: "",  
            commentText:"",
            accountNo:"",
            insuredIndicator:-1,
      
        });
        let bankId =  this.state.bankid; 
        if (bankId) {  
            const URI = constants.DRRIP_AII_API + "institution/" + bankId;
            axios
                .get(URI)
                .then(resp => this.loadBankData(resp.data))
                .catch(err => { 
                    alert("Failed to fetch bank data");
          
                    return null;
                });
        } 
    };

    getPayoutBankData = () => { 
        let bankId = this.state.bankid;
        let accountNumber= this.state.accountNo;
        // in this function send reCaptcha token that is part of the state with the request
        if (bankId) {
            const URI = constants.DRRIP_AII_API + "account/" + accountNumber +"/institution/"  + bankId ; 
            axios
                .get(URI)
                .then(resp => this.loadPayoutBankData(resp.data))
                .catch(err => { 
                    return null;
                });
        } 
    };

  

    dateDiffInDays(date1: Date, date2: Date) {
    
        return Math.round((date2.valueOf()-date1.valueOf())/(1000*60*60*24));
    }
  
    loadBankData = (data: any) => {  
  
        var msDiff=this.dateDiffInDays( new Date(data.closedDate ),new Date()); // 4 days till XM
        this.setState({
            assetXferInd: "",  
            commentText:"",
        });
        this.setState({
            loading: false,
            bankName: data.legalName,
            fund: "" + data.fundCode,      
            closedDate: new Date(data.closedDate).toLocaleString("default", { month: "long", day: "numeric", year: "numeric" }),
            assetXferInd: data.assetXferInd,  
            commentText: data.commentText,
            closedDays:msDiff,
            nodata:"",
            insuredIndicator:-1,
            url: {
                institutionId:"",
                link: "",
                linkText: "",
            },
            // siteKey:"",
        }); 
    };
             
    loadPayoutBankData = (data: any) => { 
        this.setState({
            commentText: "",  
        });
        if(!data) {
            this.setState({ nodata : "We apologize, but the system is unable to locate the account number you entered. Please confirm your account number and enter the number again. If you continue to encounter issues with locating your account number, please call 888-206-4662 for additional assistance." ,
                insuredIndicator:-1,});
            return;
        }
      
        this.setState({
            nodata:"", 
            insuredIndicator:data.insuredIndicator,
            commentText: data.commentText,
            url: {
                institutionId:data.url.institutionId,
                link: data.url.link,
                linkText: data.url.linkText, 
            }, 
      
        });  
    };

    setAccountNumber(lValue: any) {   
    
        var letters = /[^A-Za-z0-9-.]+/g;
        if (lValue.match(letters)) {
            return;
        }
    
        this.setState({accountNo: lValue });
    
    } 
 
    handleChange = (e: any) => { 
        if(e.target.name!=="AccountNumber") {  
            this.setState({bankid:e.target.value}); 
        }
    };
  
  
    handleClick = (e: any) => {
        e.preventDefault(); 
        let that = this;   

        that.getBankData(); 
    };

    handlePayoutClick = (e: any) => {
        e.preventDefault();
        let that = this; 
        that.getReCaptchaToken();
    }; 

    getSiteKey = async () => {  
     
        const URI = constants.DRRIP_AII_API + "account/siteKey"; 
        // console.log(URI);
        axios
            .get(URI)
            .then(resp => this.siteSiteKey(resp.data))
            .catch(err => { 
                return null;
            });  
    };
  
    siteSiteKey = (data: any) => {  
        this.setState({ siteKey:data})  ;  
    }; 
  
    getReCaptchaToken = async () => {  
        if (this.reRef && this.reRef.current) {
            let token = await this.reRef.current.executeAsync(); 
            this.reRef.current.reset();
      
            if (token) {  
                const URI =  constants.DRRIP_AII_API + "account/token/" + token;  
                axios
                    .get(URI)
                    .then(resp => { 
                        if(resp.data===true) {   
                            this.getPayoutBankData();
                        } else {
                            console.log("You are not authorized.....");
                        }

                    });  
            } 
 
     
        }
    };

  

    render() { 
        return (
            <React.Fragment>
                <div  className="grid-container mobile-padding-x-neg-3">  
                    <div className="padding-top-1px tablet:padding-y-0 grid-row margin-x-neg-0 tablet:margin-x-0"> 
                        <div className="grid-col-10 order-1 tablet:order-2 tablet:margin-x-0 margin-bottom-2 tablet:margin-y-0" >
                            <h1 className="maintitle">
                    Is My Account Fully Insured?
                            </h1>
                            <br />  <br /> 
                            <span >
                        This tool allows customers of a failed bank to determine whether their accounts are fully insured or if they need to contact FDIC. In either case, a link to specific contact information will be provided. Information on a failed bank will become available no later than the first business day after the bank fails and will remain posted for 30 days.
                            </span>
                            <br /> 
                            <br /> 
                            <span >
                        To determine your account status, first select your bank below and click Find. On the subsequent screen, you will need to enter each of your accounts separately to see the insured status of each account.
                            </span>
                            <br /> 
                   
                            <div >
                                <br /> 
                                <span className="boldtext"><label htmlFor="SelectBank">Select a Bank </label></span>
                                <div>
                                    <div className="ds-l-row ds-u-justify-content--left"> 
                                        <div className="ds-l-col-auto ds-u-margin-left--2 ds-u-margin-right--2">
                                            {["legalName"].map(key => ( 
                                                <select id='SelectBank' onChange={this.handleChange} className="styled">
                                                    <option key={""} value={""}>---Select--</option>
                                                    {this.state.banklist.map(({ [key]: value,["id"] : id}) => <option key={value} value={id} id={id}>{value}</option>)}
                                                </select>


                                            ))}
                            
                                        </div>
                                        <div className="ds-l-col--auto">
                                            <Button className="ds-c-button ds-c-button--primary" key="primary"  onClick={this.handleClick}>{"Find"}</Button>  
                           
                                        </div>  
                                        <div>

                         
                                        </div>
                                        <div>
                         
                         

                                            { this.state.assetXferInd==="Y"   && (
                                                <div className="ds-l-col--auto ds-u-justify-content--left"> 
                                                    <br></br>
                                                    <hr />
                                                    <b> { this.state.commentText } </b>   
                                                    <br></br><br></br>
                           For more information go to   <a href="https://www.fdic.gov/resources/resolutions/bank-failures/failed-bank-list/">Failed Bank Page</a>
                             
                                                </div>    
                                            )} 
                                            {this.state.assetXferInd==="N"  && this.state.closedDays < 30 && (
                             
                                                <div className="ds-l-col--auto ds-u-justify-content--left"> 
                                                    <br/>
                                                    <br></br>
                                                    <hr />
                                                    <span>Enter each account number you have at the failed institution one at a time. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span>
                                                    <ReCAPTCHA 
                                                        sitekey={this.state.siteKey} 
                                                        // sitekey={constants.RECAPTCHA_SITE_KEY} 
                                                        size="invisible" 
                                                        badge="bottomright" 
                                                        ref={this.reRef} /> 
                                                    <br/>
                                                    <br/>
                                                    <span><b>Bank Name: </b> { this.state.bankName} </span>
                                                    <br/>
                             
                                                    <br/>
                                                    <span>Please enter your account number and do not include any spaces:</span>
                                                    <div className="ds-l-col--auto">
                                                        <TextField
                                                            label="Account Number"
                                                            name="AccountNumber"
                                                            id="AccountNumber"
                                                            type="text" 
                                                            value= {this.state.accountNo}
                                                            onChange={this.handleOnChange}
                                                        /> 
                                                        <div className="ds-1-col--auto">
                                                            <Button className="ds-c-button ds-c-button--primary" key="primary" onClick={this.handlePayoutClick}>{"Find"}</Button>  
                                                            {"  "}</div>
                                                    </div>   
                                                    <br/> 
                                                </div>
                            
                            
                                            )} 
                                            <div>   

                                                { this.state.nodata.length>0  &&  (
                                                    <div className="ds-l-col--auto">
                                                        <hr />
                                                        { "We apologize, but the system is unable to locate the account number you entered. Please confirm your account number and enter the number again. If you continue to encounter issues with locating your account number, please call 888-206-4662 for additional assistance." }  
                                                    </div>
                                                )} 
                                            </div>    
                                            { this.state.assetXferInd==="N"  && this.state.closedDays > 30 && (
                                                <div className="ds-l-col--auto">
                                                    <br></br>
                                                    <hr />
                                                    <b> { payOutMessage } </b> </div>    
                                            )}
                                            {this.state.insuredIndicator===1 && this.state.assetXferInd==="N" && (
                                                <div className="ds-l-col--auto" id="fulltransDiv">  
                                                    <span> Account {  window.localStorage.getItem("accountNo")  } is fully insured.   </span> 
                                                    <br></br>
                              
                                                    <br></br>
                                                    <span>  { this.state.commentText}   </span> 
                                                    <br></br>
                                                    <br></br>
                                                    <span> <a href={ this.state.url.link }>{ this.state.url.linkText } </a>  </span>  
                                                    <br></br>
                                                    <br></br>
                              You can review your insurance determination and communicate about your account(s) with the FDIC using the  <a href="https://resolutions.fdic.gov/claimsportal">FDIC Claims Portal</a>. 
                             
                             
                                                </div>
                                            )} 
                                            { this.state.assetXferInd==="N"  && this.state.insuredIndicator===0 && (
                                                <div className="ds-l-col--auto"> 
                             
                                                    <br></br>
                                                    <span> <br></br>This is in reference to the specific account  {  window.localStorage.getItem("accountNo")  }  you entered.  The institution {this.state.bankName} was closed on {  this.state.closedDate }.   </span> 
                                                    <br></br>
                                                    <br></br>
                                                    <span> The FDIC requires additional information to determine your insurance coverage. </span>  
                                                    <br></br>
                                                    <br></br>
                                You can review your insurance determination and communicate about your account(s) with the 	FDIC using the <a href="https://resolutions.fdic.gov/claimsportal">FDIC Claims Portal</a>.
                               
                                                </div>    
                                            )} 
                                        </div> 
                                    </div>  </div> 
                            </div> 
                            <br /> 
                            <br /> 
                        </div>
                    </div>
                </div>
            </React.Fragment>
      
        );
    } 
} 

export default BankSearch;

